module.exports = __webpack_public_path__ + "static/44-halfworld-dec2018-175feef2649332ca8b78d9d4b3b17e1a.jpg";